import { ReactNode, useState, CSSProperties } from 'react'

import classNames from 'classnames'

import { CommonHorizontalArrow7Icon, CommonInfoIcon, CommonClose4Icon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'

import styles from './Section.module.scss'

interface SectionProps {
  children: React.ReactNode
  className?: string
  noMargin?: boolean
  style?: CSSProperties
}
export function Section({ children, className, noMargin, style }: SectionProps) {
  return (
    <div
      className={classNames(styles.section, className, {
        [styles.type_no_margin]: noMargin,
      })}
      style={style} // Note: 광고배너 섹션 처럼 background-color가 인라인스타일로 적용되어야 하는 경우 때문에 추가
    >
      <div className={styles.section_inner}>{children}</div>
    </div>
  )
}

interface SectionHeaderProps {
  title?: ReactNode
  count?: number
  extra?: ReactNode
  guide?: ReactNode
  clickHandler?: () => void
  description?: string
  isSub?: boolean
  tooltip?: ReactNode
}
export function SectionHeader(props: SectionHeaderProps) {
  const { title, count, extra, guide, clickHandler, description, isSub, tooltip } = props
  const [showGuide, setShowGuide] = useState(false)

  // const TitleElement = isSub ? 'h3' : 'h2'
  const TitleInnerElement = clickHandler ? Clickable : 'div'

  return (
    <>
      <h2 className={classNames(styles.section_title, { [styles.type_sub]: isSub })}>
        {/* 툴팁 */}
        {tooltip && <div className={styles.ly_tooltip}>{tooltip}</div>}
        <TitleInnerElement className={styles.inner} onClick={clickHandler}>
          {title && (
            <div className={styles.title_area}>
              <span className={styles.title}>{title}</span>
              {count && <em className={styles.count}>{count}</em>}
              {guide && (
                <>
                  <Clickable
                    className={styles.btn_guide}
                    onClick={e => {
                      e.stopPropagation()
                      setShowGuide(!showGuide)
                    }}
                  >
                    <CommonInfoIcon className={styles.icon} aria-hidden="true" />
                    <span className="place_blind">안내</span>
                  </Clickable>
                  {showGuide && (
                    <div className={styles.ly_guide}>
                      {guide}
                      <Clickable
                        className={styles.btn_close}
                        onClick={e => {
                          e.stopPropagation()
                          setShowGuide(!showGuide)
                        }}
                      >
                        <CommonClose4Icon className={styles.icon} aria-hidden="true" />
                        <span className="place_blind">안내레이어 닫기</span>
                      </Clickable>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {extra && <div className={styles.extra_area}>{extra}</div>}
          {clickHandler && <CommonHorizontalArrow7Icon className={styles.icon_arrow} aria-hidden="true" />}
        </TitleInnerElement>
      </h2>
      {description && <div className={styles.section_description}>{description}</div>}
    </>
  )
}

interface SectionContentProps {
  children: ReactNode
}
export function SectionContent(props: SectionContentProps) {
  const { children } = props

  return <div className={styles.section_content}>{children}</div>
}
